import { Directive, Inject, InjectionToken, Injector, Optional } from '@angular/core';
import { Store } from '@ngxs/store';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Observable } from 'rxjs';

import { FlowState, SetPaymentService } from '@pe/checkout/store';
import {
  FlowInterface,
  NodePaymentResponseInterface,
  PaymentMethodEnum,
  PaymentOptionInterface,
} from '@pe/checkout/types';

import { PAYMENT_OPTION_DATA } from './payment-option-data.token';

export const ABSTRACT_PAYMENT_SERVICE = new InjectionToken<AbstractPaymentService>('ABSTRACT_PAYMENT_SERVICE');

@Directive()
export abstract class AbstractPaymentService<T = any> {

  @SelectSnapshot(FlowState.flow) protected flow: FlowInterface;

  @SelectSnapshot(FlowState.paymentMethod) protected paymentMethod: PaymentMethodEnum;

  abstract postPayment(): Observable<NodePaymentResponseInterface<T> | boolean>;

  protected readonly store = this.injector.get(Store);

  public splitPaymentType = this.paymentOptionData?.paymentMethod;

  constructor(
    protected injector: Injector,
    @Optional() @Inject(PAYMENT_OPTION_DATA) protected paymentOptionData: PaymentOptionInterface
  ) {
    this.store.dispatch(new SetPaymentService(this));
  }

  public redirect?(): void;
}
